export default function pyxtechCountryVendorColumnSpecification(config) {
    const { pyxtechCountryVendorDetails = [], refusedVendors = [] } = config.data;
    let result = {};
    let tableData = [];

    pyxtechCountryVendorDetails.forEach((pyxtechVendor, index) => {
        let row = [];
        let textColor = "";
        let fontWeight = "";
        const rowId = pyxtechVendor.quotingPartners;
        config.columns.forEach(column => {
            let columnValue = "";
            let isDisabled = refusedVendors.includes(pyxtechVendor.vendorName);
            let customEventHandler = null;
            let isOverflowingContent = false;
            let columnValueData = null;
            let displayAsIs = column.data.displayInBodyAsIs;

            if (column.data.displayInBodyAs == "string") {
                if (column.id === "quotingPartners") {
                    displayAsIs = true;
                    columnValue = pyxtechVendor.vendorName;
                } else if (column.id === "currency") {
                    displayAsIs = true;
                    columnValue = pyxtechVendor.currency || "";
                } else if (column.id === "listOfCountriesQuoted") {
                    displayAsIs = true;
                    columnValue = pyxtechVendor.listOfCountriesQuoted || "";
                } else if (column.id === "assetsQuoted") {
                    displayAsIs = true;
                    columnValue = pyxtechVendor.assetsQuoted || "";
                } else if (column.id === "assetsWithPyxtechRV") {
                    displayAsIs = true;
                    columnValue = pyxtechVendor.assetsWithPyxtechRV || "0";
                } else if (column.id === "vendorBuybackValue") {
                    displayAsIs = true;
                    columnValue = pyxtechVendor.vendorBuybackValue;
                } else if (column.id === "vendorBuybackValueWithPyxtechRV") {
                    displayAsIs = true;
                    columnValue = pyxtechVendor.vendorBuybackValueWithPyxtechRV || "";
                } else if (column.id === "recommendedResidualValue") {
                    displayAsIs = true;
                    columnValue = pyxtechVendor.recommendedResidualValue || "";
                } else if (column.id === "countriesWithResidualValues") {
                    displayAsIs = true;
                    columnValue = pyxtechVendor.countriesWithResidualValues || "";
                } else if (column.id === "comparisonRV") {
                    displayAsIs = true;
                    columnValue = pyxtechVendor.comparisonRV ? `${pyxtechVendor.comparisonRV}%` : "";
                    fontWeight = "bold";
                    if (pyxtechVendor.comparisonRV > 90) {
                        textColor = "green";
                    } else if (pyxtechVendor.comparisonRV <= 90 && pyxtechVendor.comparisonRV >= 50) {
                        textColor = "#ffcc4e";
                    } else {
                        textColor = "red";
                    }
                }
            }

            row.push({
                [column.id]: {
                    id: column.id + "|" + rowId,
                    type: column.data.displayInBodyAs,
                    value: columnValueData || columnValue,
                    width: column.width,
                    disabled: isDisabled,
                    displayAsIs: displayAsIs,
                    isOverflowingContent: isOverflowingContent,
                    showInMobileViewAs: column.showInMobileViewAs,
                    clickHandler: customEventHandler,
                    textColor: textColor,
                    fontWeight: fontWeight
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    });


    result['columns'] = config.columns;
    result['data'] = tableData;

    return result;
}